import React, { useEffect, useState } from 'react';
import { isNil } from 'lodash-es';
import { useParams } from 'react-router-dom';
import { NavigationMenu } from './NavigationMenu/NavigationMenu';
import './Menu.scss';
import { useGetMenuByIdQuery } from '../store/menu/menuApi';
import { EditItem } from '../modules/EditItem/EditItem';
import { Category } from './Category/Category';
import { useModal } from '../providers/ModalProvider/ModalProvider';
import { UpdateMenu } from './UpdateMenu/UpdateMenu';

export const Menu = (): JSX.Element => {
	const { menuId } = useParams<{ menuId?: string }>();
	const { data: menu } = useGetMenuByIdQuery(menuId, { skip: isNil(menuId) });
	const { categories = [] } = menu ?? { categories: [] };
	const [selectedCategoryId, setSelectedCategoryId] = useState<string>(categories?.[0]?.id ?? null);
	const { openModal } = useModal();

	useEffect(() => {
		if (isNil(selectedCategoryId) && categories.length > 0) {
			setSelectedCategoryId(categories?.[0]?.id);
		}
	}, [categories, selectedCategoryId]);

	const handleNewCategorySelected = (newCategoryId: string): void => {
		setSelectedCategoryId(newCategoryId);
	};

	const handleEditMenuClicked = (): void => {
		const closeModal = openModal(
			<UpdateMenu
				onSubmit={(): void => {
					closeModal();
				}}
				onCancel={(): void => {
					closeModal();
				}}
				menuId={menuId}
			/>
		);
	};

	return (
		<div className="menuContainer">
			<div className="menuTitle" onClick={handleEditMenuClicked}>
				{menu?.title}
				<EditItem />
			</div>
			<NavigationMenu onCategoryChange={handleNewCategorySelected} />
			<Category menuId={menuId} categoryId={selectedCategoryId} />
		</div>
	);
};
